import type { z } from 'zod'

export class ConfigError extends Error {
  override name = 'ConfigError'
}

/** One line per issue: `file.path.to.field: message`. */
export function formatIssues(file: string, error: z.ZodError): string {
  return error.issues
    .map((issue) => `${[file, ...issue.path.map(String)].join('.')}: ${issue.message}`)
    .join('\n')
}
